import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import BigCalendar from "./react-big-calendar";
import withDragAndDrop from "./react-big-calendar/addons/dragAndDrop";
import Event from "./Event";
import theme from "../../styles/theme";

function eventStyleGetter(event, start, end, isSelected) {
  const style = {
    backgroundColor: isSelected
      ? theme.palette.primary.dark
      : theme.palette.primary[500],
    opacity: event.requesting ? 0.7 : 1,
  };
  return {
    style,
  };
}

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const DragAndDropCalendar = withDragAndDrop(BigCalendar);

const DragNDropCalendar = ({
  events,
  handleSelectSlot,
  handleSelectEvent,
  handleEventDrop,
  handleEventResize,
  handleSyncFailed,
  handleDeletePlanning,
}) => (
  <DragAndDropCalendar
    selectable
    events={events}
    resizable
    step={60}
    timeslots={1}
    toolbar={false}
    views={["week"]}
    defaultView="week"
    defaultDate={new Date(2018, 0, 1)}
    formats={{
      dayFormat: "dddd",
    }}
    onSelectSlot={handleSelectSlot}
    onSelectEvent={handleSelectEvent}
    onEventDrop={handleEventDrop}
    onEventResize={handleEventResize}
    components={{
      week: { event: Event({ handleSyncFailed, handleDeletePlanning }) },
    }}
    eventPropGetter={eventStyleGetter}
  />
);

DragNDropCalendar.propTypes = {
  events: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleSelectSlot: PropTypes.func.isRequired,
  handleSelectEvent: PropTypes.func.isRequired,
  handleEventDrop: PropTypes.func.isRequired,
  handleEventResize: PropTypes.func.isRequired,
  handleSyncFailed: PropTypes.func.isRequired,
  handleDeletePlanning: PropTypes.func.isRequired,
};

export default DragDropContext(HTML5Backend)(DragNDropCalendar);



// WEBPACK FOOTER //
// ./src/pages/plannings/DragNDropCalendar.jsx